export let hrms13xColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRPM81X1',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 120px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRPM81X1',
      labelIndex: '80',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codcomp',
      name: '',
      labelCodapp: 'HRPM81X1',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codpos',
      name: '',
      labelCodapp: 'HRPM81X1',
      labelIndex: '100',
      style: 'min-width: 200px;'
    }, {
      key: 'numlvl',
      name: '',
      labelCodapp: 'HRPM81X1',
      labelIndex: '110',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'dteempmt',
      name: '',
      labelCodapp: 'HRPM81X1',
      labelIndex: '120',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }
  ]
  let tab2Columns = [
    {
      key: 'numseq',
      name: '',
      labelCodapp: 'STDEMPC2',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'desnoffi',
      name: '',
      labelCodapp: 'STDEMPC2',
      labelIndex: '30',
      style: 'min-width: 200px;'
    }, {
      key: 'deslstpos',
      name: '',
      labelCodapp: 'STDEMPC2',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'dtestart',
      name: '',
      labelCodapp: 'STDEMPC2',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'dteend',
      name: '',
      labelCodapp: 'STDEMPC2',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }
  ]
  let tab3table1Columns = [
    {
      key: 'dteeffec',
      name: '',
      labelCodapp: 'STDEMPC3',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'old_salary',
      name: '',
      labelCodapp: 'STDEMPC3',
      labelIndex: '40',
      class: 'align-right',
      style: 'min-width: 100px;'
    }, {
      key: 'amtincadj1_desc',
      name: '',
      labelCodapp: 'STDEMPC3',
      labelIndex: '50',
      class: 'align-right',
      style: 'min-width: 100px;'
    }
  ]
  let tab3table2Columns = [
    {
      key: 'dteyreap',
      name: '',
      labelCodapp: 'STDEMPC3',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 100px;',
      dataType: 'year'
    }, {
      key: 'grdap',
      name: '',
      labelCodapp: 'STDEMPC3',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 100px;'
    }
  ]
  let tab4Columns = [
    {
      key: 'codpunsh_desc',
      name: '',
      labelCodapp: 'STDEMPC4',
      labelIndex: '20',
      style: 'min-width: 200px;'
    }, {
      key: 'punish_dte',
      name: '',
      labelCodapp: 'STDEMPC4',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 200px;'
    }, {
      key: 'desmist1',
      name: '',
      labelCodapp: 'STDEMPC4',
      labelIndex: '40',
      style: 'min-width: 300px;'
    }
  ]

  return {
    en: {
      index: indexColumns,
      tab2: tab2Columns,
      tab3table1: tab3table1Columns,
      tab3table2: tab3table2Columns,
      tab4: tab4Columns
    },
    th: {
      index: indexColumns,
      tab2: tab2Columns,
      tab3table1: tab3table1Columns,
      tab3table2: tab3table2Columns,
      tab4: tab4Columns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms13x.js